import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '@/firebase';

type TesttypeSummary = {
  paper: number;
  online: number;
};

export default function OnlineTestSummaryPage() {
  const [summary, setSummary] = useState<TesttypeSummary>({ paper: 0, online: 0 });
  const [loading, setLoading] = useState(true);

    useEffect(() => {
      const fetchSummary = async () => {
        setLoading(true);
        try {
        const snapshot = await getDocs(collection(db, 'dailydata'));
        let paperTotal = 0;
        let onlineTotal = 0;

        snapshot.docs.forEach((docSnapshot) => {
          const data = docSnapshot.data() as { test_paper?: unknown; test_online?: unknown };
          paperTotal += typeof data.test_paper === 'number' ? data.test_paper : 0;
          onlineTotal += typeof data.test_online === 'number' ? data.test_online : 0;
        });

        setSummary({
          paper: paperTotal,
          online: onlineTotal,
        });
        } catch (error) {
          console.error('Error fetching online test summary:', error);
        } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, []);

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-800">オンラインテスト集計</h1>
        <Link
          to="/admin/answers"
          className="inline-flex items-center rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm font-semibold text-emerald-700 hover:bg-emerald-100"
        >
          テスト一覧
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
          <div className="text-sm text-gray-500">paper（用紙）</div>
          <div className="mt-2 text-3xl font-bold text-gray-800">{loading ? '...' : summary.paper}</div>
        </div>
        <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
          <div className="text-sm text-gray-500">online（オンライン）</div>
          <div className="mt-2 text-3xl font-bold text-gray-800">{loading ? '...' : summary.online}</div>
        </div>
      </div>
    </div>
  );
}
